import { Link } from 'react-router-dom';
import type { Student } from '@/types';
import { formatDate } from '@/lib/datetime';

interface EndedStudentRowProps {
  student: Student;
  busy?: boolean;
  onReactivate: (id: string) => void;
}

export default function EndedStudentRow({ student, busy, onReactivate }: EndedStudentRowProps) {
  const initial = (student.name || '?').trim().charAt(0).toUpperCase();

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-background-200 bg-background-100 p-4">
      <div className="flex min-w-0 items-center gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background-200 text-sm font-bold text-foreground-600">
          {initial}
        </span>
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <Link
              to={`/students/${student.id}`}
              className="truncate text-sm font-semibold text-foreground-900 transition hover:text-primary-700"
            >
              {student.name}
            </Link>
            <span className="flex items-center gap-1 rounded-full bg-background-200 px-2 py-0.5 text-[11px] font-semibold text-foreground-600">
              <i className="ri-user-unfollow-line"></i>
              수업 종료
            </span>
          </div>
          <p className="mt-0.5 truncate text-xs text-foreground-500">
            {student.school || '학교 미입력'} · {student.grade || '학년 미입력'}
          </p>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <span className="text-xs text-foreground-500">종료일 {formatDate(student.ended_at)}</span>
        <button
          type="button"
          onClick={() => onReactivate(student.id)}
          disabled={busy}
          className="flex items-center gap-1.5 rounded-md border border-primary-300 bg-background-50 px-3 py-1.5 text-xs font-semibold text-primary-700 transition hover:bg-primary-50 disabled:opacity-50 whitespace-nowrap"
        >
          {busy ? (
            <i className="ri-loader-4-line animate-spin"></i>
          ) : (
            <i className="ri-restart-line"></i>
          )}
          수업 재개
        </button>
      </div>
    </div>
  );
}